<template>
  <section>
    <h2 class="text-center">Ban Visitor</h2>

    <!-- Start Date -->
    <div class="form-group">
      <label>Start Date</label>
      <b-form-datepicker
        v-model="createBanDto.start_date"
        :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
        today-button reset-button close-button
        @input="createBanDto.end_date = null"
      />
    </div>

    <!-- End Date -->
    <div class="form-group">
      <label>End Date</label>
      <b-form-datepicker
        v-model="createBanDto.end_date"
        :min="createBanDto.start_date"
        :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
        today-button reset-button close-button
      />
    </div>

    <!-- Reason -->
    <div class="form-group">
      <label for="reason">Reason</label>
      <textarea
        id="reason"
        v-model="createBanDto.reason"
        class="form-control"
      />
    </div>

    <!-- Explanation -->
    <small>
      The visitor will be unable to take part in social visits
      for the duration of this ban
    </small>

    <b-btn
      :disabled="!banValid()"
      class="full-width mt-1"
      variant="success" @click="addBan()"
    >
      Add Ban
    </b-btn>
  </section>
</template>

<script>
  import { logger } from '@/util/logger';
  import SocialBansService from '@/services/SocialBansService';

  export default {
    name: 'AddSocialBan',
    props: {
      visitor_user_id: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        createBanDto: {
          user_id: this.visitor_user_id,
          reason: '',
          start_date: null,
          end_end: null,
        },
      };
    },
    methods: {
      banValid() {
        if (!this.createBanDto.user_id || this.createBanDto.user_id.length < 1) {
          return false;
        }
        if (!this.createBanDto.start_date) {
          return false;
        }
        if (!this.createBanDto.end_date) {
          return false;
        }
        return true;
      },
      addBan() {
        if (!this.banValid()) {
          this.$toast.info('Please check you have filled all the fields out correctly');
          return;
        }

        SocialBansService.createSocialBan(this.createBanDto).then(() => {
          this.$toast.success('Added social ban successfully!', {
            toastClassName: ['toast-std', 'success-toast'],
          });
          this.close();
        }).catch(err => {
          logger.error('Error creating social ban', err, null, 'AddBan:addBan');
          this.$toast.error('Error creating social ban. Please try again', {
            toastClassName: ['toast-std', 'warning-toast'],
          });
        });
      },
      close() {
        this.$emit('close');
      },
    },
  };
</script>
